import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useBoundaries } from "../../../context/boundary";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";

const OverlayHeader = () => {
  const {
    selectedBoundary: boundary,
    setSelectedBoundary,
    setOverlayCoordinate,
  } = useBoundaries();

  const navigate = useNavigate();

  const closeOverlay = () => {
    setSelectedBoundary(undefined);
    setOverlayCoordinate(undefined);
    navigate("/");
  };

  return (
    <div
      className="p-2 bg-primary text-white d-flex align-items-center justify-content-between"
      style={{ borderTopLeftRadius: 7, borderTopRightRadius: 7 }}
    >
      <span className="fw-semibold mx-auto">{boundary?.name}</span>
      <div className="d-flex align-items-center">
        <FontAwesomeIcon
          icon={faTimes}
          role="button"
          aria-label="Close"
          onClick={closeOverlay}
          style={{
            cursor: "pointer",
            fontSize: "0.9rem",
          }}
        />
      </div>
    </div>
  );
};

export default OverlayHeader;
